export default {
  statistics: {
    total_followers: 'Total de seguidores',
    emails_sent: 'E-mails enviados',
    emails_opened: 'E-mails abertos',
    emails_clicked: 'E-mails clicados',
    emails_average_open_rate: 'Taxa de abertura de e-mails',
    emails_average_click_rate: 'Taxa de cliques de e-mails',
    push_notifications_sent: 'Notificações push enviadas',
    push_notifications_clicked: 'Notificações push clicadas',
  },
};
